interface QRCodeProps {
  value: string;
  size?: number;
}

/**
 * Simple SVG-based QR code renderer.
 * Generates a deterministic pattern from the input string.
 */
export default function QRCode({ value, size = 160 }: QRCodeProps) {
  const gridSize = 21;
  const cellSize = size / gridSize;

  // Simple hash to generate deterministic pattern
  const hash = (str: string, seed: number): number => {
    let h = seed;
    for (let i = 0; i < str.length; i++) {
      h = ((h << 5) - h + str.charCodeAt(i)) | 0;
    }
    return h;
  };

  const cells: boolean[][] = [];
  for (let y = 0; y < gridSize; y++) {
    cells[y] = [];
    for (let x = 0; x < gridSize; x++) {
      // Finder patterns (three corners)
      const inFinderTL = x < 7 && y < 7;
      const inFinderTR = x >= gridSize - 7 && y < 7;
      const inFinderBL = x < 7 && y >= gridSize - 7;

      if (inFinderTL || inFinderTR || inFinderBL) {
        const lx = inFinderTR ? x - (gridSize - 7) : x;
        const ly = inFinderBL ? y - (gridSize - 7) : y;
        // Outer border, inner square
        const isOuter = lx === 0 || lx === 6 || ly === 0 || ly === 6;
        const isInner = lx >= 2 && lx <= 4 && ly >= 2 && ly <= 4;
        cells[y][x] = isOuter || isInner;
      } else {
        // Data area: deterministic from value
        cells[y][x] = (hash(value, y * gridSize + x) & 3) === 0;
      }
    }
  }

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="rounded-lg">
      <rect width={size} height={size} fill="white" />
      {cells.map((row, y) =>
        row.map((cell, x) =>
          cell ? (
            <rect
              key={`${x}-${y}`}
              x={x * cellSize}
              y={y * cellSize}
              width={cellSize}
              height={cellSize}
              fill="#0f172a"
            />
          ) : null
        )
      )}
    </svg>
  );
}
